import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const DeliveryStatus = ApplicationRecord.extend({
  attrs: {
    delivery_id: attr({ type: Number }),
    name: attr(),
  },
  static: {
    endpoint: '/delivery_statuses',
    jsonapiType: 'deliveries-delivery_statuses',
    statuses: [
      'skipped',
      'cancelled',
      'scheduled',
      'billing',
      'payment_pending',
      'billed',
      'billing_failed',
      'billing_timed_out',
      'cancelled_after_billing',
      'delinquent',
    ],
    cancellablePostBillingStatuses: [
      'billed', 'billing_failed', 'billing_timed_out', 'payment_pending',
    ],
    initialiseCancelledAfterBillingInstance(deliveryId) {
      if (!Number.isInteger(parseInt(deliveryId, 10))) {
        throw new Error('Delivery Id MUST be an integer');
      }

      return new DeliveryStatus({
        delivery_id: deliveryId,
        name: 'cancelled_after_billing',
      });
    },
  },
});

export default DeliveryStatus;
